import React from 'react';
import UnifiedProfileModal from './profile/UnifiedProfileModal';

interface SurveySubmission {
  id: string;
  full_name: string;
  email: string;
  profile_name?: string | null;
  scores: any;
  selected_words: any;
  selected_words_text: any;
  completed_at: string;
  created_at: string;
  cached_insights?: Record<string, any>;
}

interface ProfileModalProps {
  submission: SurveySubmission | null;
  isOpen: boolean;
  onClose: () => void;
  onSubmissionUpdate?: (updatedSubmission: SurveySubmission) => void;
}

const ProfileModal: React.FC<ProfileModalProps> = ({ submission, isOpen, onClose, onSubmissionUpdate }) => {
  return (
    <UnifiedProfileModal 
      submission={submission}
      isOpen={isOpen}
      onClose={onClose}
      onSubmissionUpdate={onSubmissionUpdate}
    />
  );
};

export default ProfileModal;
